import { application } from "./bootstrap";
import { createConfigurationReader } from "@components-fabric";
import { webSiteScreens } from "../_website/screens";
import { routes } from "./app-routes.react-router";
import { map } from "ramda";
import {
  buildNestedRoutes,
  createRouteFromScreenProps,
} from "../components-system/routing/create-nested-routes";

/**
 * Function: appRouter
 *
 * This function configures and starts the application's router based on the user's authentication status and role.
 *
 * @param {boolean} isAuthenticated - Indicates if the user is authenticated.
 * @param {string | undefined} role - The role of the authenticated user.
 *
 * Returns:
 * @returns {any} The configured router for the application.
 */
export const appRouter = (
  isAuthenticated: boolean,
  role: string | undefined
) => {
  // Create a configuration reader and add screens to it
  const reader = createConfigurationReader();
  reader.add([...webSiteScreens]);
  reader.read();

  // Get the routing service and screen provider from the application
  const routingService = application.routing as any;
  const screens = reader.get();
  const screenProvider = application.screenProvider;
  screenProvider.add(map((x) => ({ key: x.id, value: x } as any), screens));

  // Create routes from screen properties based on authentication
  const screenRoutes = map(
    (props) => createRouteFromScreenProps(props, isAuthenticated, role),
    screens
  );

  // Add routes to the routing service
  routingService.addRootieRoutes(screenRoutes.filter((x) => x !== undefined));
  routingService.addRoutes([...routes]);

  // Start the routing service and set the router in the application navigator
  routingService.start();
  const appRoute = routingService.router();
  application.navigator.setRouter(appRoute);

  return appRoute;
};
